import { defineMessages } from 'react-intl'

export default defineMessages({
  resetRates: {
    id: 'containers.AdminSupplierOnboarding.components.Supplier.components.ResetRatesMenuItem.resetRates',
    defaultMessage: 'Reset rates',
  },
  confirm: {
    id: 'containers.AdminSupplierOnboarding.components.Supplier.components.ResetRatesMenuItem.confirm',
    defaultMessage: 'DANGER! This will delete ALL rates (both custom and standard) from the voice talent. Do you want to proceed?',
  }
})
